import React from 'react'
import { useFormContext } from 'react-hook-form'

import s from './styles.module.scss'

import {
  ControlledHourPicker,
  HourPickerOptionsProps,
} from '../../../../../forms/hour-picker/ControlledHourPicker'
import { ISelectProposalForm } from '../../../modal-select-proposal.types'

export interface ModalSelectProposalSelectOptionsCorporateEveningEventProps {
  hoursOptions: null | {
    startAtOptions: HourPickerOptionsProps
    overStayMaxAtOptions: HourPickerOptionsProps
  }
}
export const ModalSelectProposalSelectOptionsCorporateEveningEvent = ({
  hoursOptions,
}: ModalSelectProposalSelectOptionsCorporateEveningEventProps) => {
  const { control } = useFormContext<ISelectProposalForm>() || {}

  return (
    <div className={s.formContainer}>
      <ControlledHourPicker<ISelectProposalForm>
        control={control}
        label="Heure d'arrivée"
        placeholder='--:--'
        name='hours.arrivalHour'
        fullWidth={true}
        column={true}
        hoursOptions={hoursOptions?.startAtOptions ?? null}
      />

      <ControlledHourPicker<ISelectProposalForm>
        control={control}
        label='Heure de départ'
        placeholder='--:--'
        name='hours.departureHour'
        fullWidth={true}
        column={true}
        hoursOptions={hoursOptions?.overStayMaxAtOptions ?? null}
      />
    </div>
  )
}
